import { Layers } from "lucide-react";
import { FlashcardsPanel } from "@/components/FlashcardsPanel";

export default function FlashcardsPage() {
  return (
    <div className="flex-1 overflow-y-auto scroll-thin">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-10" data-testid="flashcards-page">
        <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight flex items-center gap-3"><Layers className="h-8 w-8 text-emerald-300" />Flashcards</h1>
        <p className="text-neutral-400 mt-3 max-w-xl">Review the cards you've made from tutor answers. Tap "Make flashcard" under any answer to add more.</p>
        <FlashcardsPanel />
      </div>
    </div>
  );
}
